// Ripples on a small body of water: the discrete wave equation on a height
// grid (the classic 2D water effect of demos and games): each step the new
// height is the neighbours' average, doubled, minus the previous height, with
// a little damping. Waves reflect from the rim of a round basin.
export class RippleWater{
  constructor({n=64,center=[0,0],radius=1,damping=.985}){
    this.n=n;this.center=[...center];this.radius=radius;this.damping=damping;this.cell=2*radius/n;
    this.now=new Float32Array(n*n);this.before=new Float32Array(n*n);this.mask=new Uint8Array(n*n);
    for(let j=0;j<n;j++)for(let i=0;i<n;i++){const [x,z]=this.position(i,j);this.mask[i+j*n]=Math.hypot(x-center[0],z-center[1])<radius?1:0;}
    this.clock=0;this.activity=0;
  }
  position(i,j){return [this.center[0]-this.radius+(i+.5)*this.cell,this.center[1]-this.radius+(j+.5)*this.cell];}
  inside(x,z){return Math.hypot(x-this.center[0],z-this.center[1])<this.radius;}
  // Push the surface down (negative) or up around a point.
  disturb(x,z,amount,radius=this.cell*2){
    const n=this.n,r=Math.max(1,Math.ceil(radius/this.cell)),ci=Math.floor((x-this.center[0]+this.radius)/this.cell),cj=Math.floor((z-this.center[1]+this.radius)/this.cell);
    for(let j=cj-r;j<=cj+r;j++)for(let i=ci-r;i<=ci+r;i++){
      if(i<0||j<0||i>=n||j>=n||!this.mask[i+j*n])continue;
      const [px,pz]=this.position(i,j),d=Math.hypot(px-x,pz-z)/radius;if(d>1)continue;
      this.now[i+j*n]+=amount*(.5+.5*Math.cos(Math.PI*d));
    }
    this.activity=1;
  }
  height(x,z){
    const n=this.n,i=Math.floor((x-this.center[0]+this.radius)/this.cell),j=Math.floor((z-this.center[1]+this.radius)/this.cell);
    return i<0||j<0||i>=n||j>=n?0:this.now[i+j*n];
  }
  step(dt){
    if(!this.activity)return;
    this.clock+=dt;const n=this.n,mask=this.mask;let energy=0,steps=0;
    while(this.clock>=1/60&&steps<4){
      this.clock-=1/60;steps++;
      const a=this.now,b=this.before;
      for(let j=0;j<n;j++)for(let i=0;i<n;i++){
        const q=i+j*n;if(!mask[q]){b[q]=0;continue;}
        // A wall reflects: a missing neighbour mirrors this cell.
        const l=i>0&&mask[q-1]?a[q-1]:a[q],r=i<n-1&&mask[q+1]?a[q+1]:a[q],d=j>0&&mask[q-n]?a[q-n]:a[q],u=j<n-1&&mask[q+n]?a[q+n]:a[q];
        b[q]=((l+r+d+u)*.5-b[q])*this.damping;energy=Math.max(energy,Math.abs(b[q]));
      }
      this.now=b;this.before=a;
    }
    if(steps&&energy<1e-5){this.now.fill(0);this.before.fill(0);this.activity=0;}
  }
}
